import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import LinkApplicationsModal from "./link-applications-modal";
import { mapActions, mapGetters } from "vuex";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { UPDATE_ACCOUNT_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import { LINK_CLIENT_PROFILE, LOAD_TIMELINE, ASSIGN_REFERRER } from "@Broker/@Modules/clients/board/store/board-actions";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EmptyApplicationHandler",
  components: {
    LinkApplicationsModal,
    SimpleButton
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ownerClients: {},
      linkingLoading: false,
      linkingStatus: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    loadingOwnerClients() {
      return isEmpty(this.ownerClients);
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [UPDATE_ACCOUNT_PERSONAL_DETAILS])), mapActions("BoardStore", [LINK_CLIENT_PROFILE, LOAD_TIMELINE, ASSIGN_REFERRER])), {}, {
    showLinkAppModal() {
      this.$refs.linkAppModal.show();
    },
    async createApplication() {
      this.$emit("create");
    },
    async linkApplication(accountUsername) {
      try {
        this.linkingLoading = true;
        const referrerId = await this.LINK_CLIENT_PROFILE({
          clientProfileId: this.clientProfileId,
          accountUsername
        });
        await this.LOAD_TIMELINE({
          id: this.clientProfileId,
          limit: 20,
          offset: 0
        });
        if (referrerId) {
          await this.ASSIGN_REFERRER({
            referrerId,
            profileId: this.clientProfileId
          });
          this.$emit("save");
        }
      } catch (e) {
        this.linkingStatus = false;
      } finally {
        this.linkingLoading = false;
      }
    }
  })
});